
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Pencil } from "lucide-react";
import { useState } from "react";
import { EditProductForm } from "./product/EditProductForm";
import { ProductFormValues } from "./product/types";

interface EditProductDialogProps {
  productId: string;
  initialValues: {
    name: string;
    description: string;
    features: string;
    link: string;
    logo: string;
    product_screen: string;
    visible?: boolean;
  };
  onProductUpdated: () => void;
}

export const EditProductDialog = ({ productId, initialValues, onProductUpdated }: EditProductDialogProps) => {
  const [open, setOpen] = useState(false);
  
  // Transform initialValues to match ProductFormValues if needed
  const formInitialValues: ProductFormValues = {
    name: initialValues.name,
    description: initialValues.description,
    features: initialValues.features,
    link: initialValues.link,
    logo: initialValues.logo,
    product_screen: initialValues.product_screen,
    visible: initialValues.visible,
  };

  const handleSuccess = () => {
    onProductUpdated();
    setOpen(false);
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="ghost" size="icon" className="text-primary hover:text-primary/80">
          <Pencil className="h-4 w-4" />
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Edit Product</DialogTitle>
        </DialogHeader>
        <EditProductForm 
          productId={productId}
          initialValues={formInitialValues}
          onSuccess={handleSuccess}
          onCancel={() => setOpen(false)}
        />
      </DialogContent>
    </Dialog>
  );
};
